import { Menu } from '@daily/shared/components/Menu';
import classNames from 'classnames';
import { memo } from 'react';

import { robotsClassName } from '../../lib/robots';

type Props = React.ComponentProps<typeof Menu>;

export const MobileMoreMenu: React.FC<React.PropsWithChildren<Props>> = memo(
  (props) => (
    <Menu
      align="left"
      cardProps={{
        style: {
          borderRadius: 8,
        },
      }}
      cardListProps={{
        style: {
          justifyContent: 'space-between',
          overflow: 'auto',
        },
      }}
      className={classNames(robotsClassName('mobile-more-menu'))}
      edgeSpacing={8}
      offsetTop={7}
      placement="top"
      position="absolute"
      {...props}
    />
  )
);
MobileMoreMenu.displayName = 'MobileMoreMenu';
